import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { CapacityOption } from "../template_offering_listing_base";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useCoalitionSpaceAnalytics } from "./coalition-space_analytics";
import { partnerConfig } from "./coalition-space_partner_config";

const Theme = lazyWithRetry(() => import("./coalition-space_theme"));

const capacityOptions: CapacityOption[] = [
  { label: "1 - 9", value: { minCapacity: 1, maxCapacity: 9 } },
  { label: "10+", value: { minCapacity: 10 } },
];

export function OfferingCoalitionSpaceListingMeetingRoom() {
  useCoalitionSpaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        filterConfig={{ capacity: true, location: true, capacityOptions }}
        partnerConfig={partnerConfig}
        data={{
          title: "Meeting Rooms",
          description:
            "Need a private space to host an off-site meeting, live-streaming event, or video conference call? Our goal is to enhance your workday by creating spaces for you to connect online or in-person and get focused work done.",
        }}
      />
    </Fragment>
  );
}
